export enum Role {
    Admin = "0",
    User = "1",
    Guest = "2"
}
  